import { Settings } from '../../../Settings';

class FrequencyGraphic
{
  constructor(parent_element, data)
  {
    this.parent_element = parent_element;
    this.freq_mhz = data.freq_mhz;
    this.rssi = data.rssi;
    this.noise = data.noise;
    this.snr = data.snr;
    this.state = data.state;

    this.snr_bars = [];
  }

  start()
  {
    this.template_element = document.querySelector('.frequency-graphic--template');

    this.container_element = this.template_element.cloneNode(true);
    this.container_element.classList.remove('frequency-graphic--template');
    this.container_element.classList.remove('hidden');

    this.mhz_element = this.container_element.querySelector('.frequency-graphic__mhz');
    this.snr_container_element = this.container_element.querySelector('.frequency-graphic__snr-container');
    this.snr_value_element = this.container_element.querySelector('.frequency-graphic__snr-bar-value');

    for (let i = 0; i < Settings.snr_bars; i++)
    {
      this.snr_bars.push(document.createElement('div'));
      this.snr_bars[i].classList.add('frequency-graphic__snr-bar');
      this.snr_bars[i].classList.add(`frequency-graphic__snr-bar--${this.state === 'true' ? 'green' : 'red'}`);
      this.snr_container_element.appendChild(this.snr_bars[i]);
    }

    this.noise_container_element = this.container_element.querySelector('.frequency-graphic__noise-container');
    this.noise_bar_element = this.container_element.querySelector('.frequency-graphic__noise-bar');
    this.noise_level_element = this.container_element.querySelector('.frequency-graphic__noise-level');

    this.mhz_element.textContent = this.freq_mhz;
    this.noise_level_element.textContent = this.noise;

    this.parent_element.appendChild(this.container_element);
    this.update_html_element(); // set initial noise bar height
  }

  update(data)
  {
    this.rssi = data.rssi;
    this.noise = data.noise;
    this.snr = data.snr;
    this.state = data.state;

    this.update_html_element();
  }

  update_html_element()
  {
    this.update_snr_bars();
    this.snr_value_element.textContent = this.snr;

    const capped_noise = Math.max(Settings.noise_min, Math.min(Settings.noise_max, this.noise));
    const normalized = (Settings.noise_max - capped_noise) / (Settings.noise_max - Settings.noise_min);

    this.noise_bar_element.height = `${normalized * Settings.noise_height}px`;
    this.noise_level_element.textContent = this.noise;
  }

  update_snr_bars()
  {
    const filled_bars = Math.min(Settings.snr_bars, Math.max(0, Math.floor(this.snr)));
    const top_filled_bar_index = Math.min(filled_bars, this.snr_bars.length - 1);

    for (let i = 0; i < Settings.snr_bars; i++)
    {
      // Set the color of the bar
      if (this.state === 'true')
      {
        this.snr_bars[i].classList.add('frequency-graphic__snr-bar--green');
        this.snr_bars[i].classList.remove('frequency-graphic__snr-bar--red');
      }
      else
      {
        this.snr_bars[i].classList.add('frequency-graphic__snr-bar--red');
        this.snr_bars[i].classList.remove('frequency-graphic__snr-bar--green');
      }

      // Set the filled state of the bar
      this.snr_bars[i].classList.remove('filled');
      if (i < filled_bars)
      {
        this.snr_bars[i].classList.add('filled');
      }
    }

    // Place the SNR value text on top of the topmost filled bar
    this.snr_bars[top_filled_bar_index].appendChild(this.snr_value_element);
  }
}

export { FrequencyGraphic };
